var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide" } }, [
    _c(
      "div",
      {
        staticClass: "modal fade",
        class: _vm.ondetail ? "show" : "show",
        style: _vm.ondetail ? "display: block; padding-left: 0px;" : "",
        attrs: { tabindex: "-1", role: "dialog" },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-dialog-centered modal-lg" },
          [
            _c("div", { staticClass: "modal-content shadow-3" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "icon icon-shape rounded-3 bg-soft-primary text-primary text-lg me-4",
                  },
                  [_c("i", { staticClass: "bi bi-box" })]
                ),
                _vm._v(" "),
                _c("div", [
                  _c("h5", { staticClass: "mb-1" }, [
                    _vm._v(_vm._s(_vm.data.type) + _vm._s(_vm.data.id)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "small",
                    { staticClass: "d-block text-xs text-muted" },
                    [
                      _c(
                        "v-tooltip",
                        {
                          staticClass: "mx-1",
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function (ref) {
                                var on = ref.on
                                var attrs = ref.attrs
                                return [
                                  Array.isArray(_vm.data.description)
                                    ? _c(
                                        "div",
                                        _vm._g(
                                          _vm._b(
                                            { staticClass: "nowrap" },
                                            "div",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(_vm.data.description[0]) +
                                              " ...\n                                    "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "small",
                            _vm._l(
                              _vm.data.description,
                              function (description, key) {
                                return _c("div", { key: key }, [
                                  _vm._v(_vm._s(description)),
                                ])
                              }
                            ),
                            0
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ms-auto" }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "vstack gap-3" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-lg-6" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "form-group mb-2 d-flex align-items-center",
                        },
                        [
                          _c(
                            "small",
                            {
                              staticClass: "input-title",
                              staticStyle: { width: "140px" },
                            },
                            [_vm._v("Cliente: ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "ml-2",
                              staticStyle: { width: "calc(100% - 140px)" },
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "form-control form-control-sm text-muted bg-white",
                                  staticStyle: {
                                    "font-size": "11px",
                                    height: "31px",
                                    display: "flex",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _vm.globalViewOption("UserDetail")
                                    ? _c(
                                        "router-link",
                                        {
                                          staticClass: "text-decoration-none",
                                          attrs: {
                                            to: {
                                              name: "UserDetail",
                                              params: {
                                                role: _vm.data.user.role.name,
                                                id: _vm.data.user.id,
                                              },
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(
                                                _vm.data.user
                                                  ? _vm.data.user.name +
                                                      "-" +
                                                      "" +
                                                      _vm.data.type +
                                                      _vm.data.id
                                                  : ""
                                              ) +
                                              "\n                                                "
                                          ),
                                          _c("i", {
                                            staticClass:
                                              "fa-solid fa-square-arrow-up-right",
                                          }),
                                        ]
                                      )
                                    : _c("div", [
                                        _vm._v(
                                          "\n                                                " +
                                            _vm._s(
                                              _vm.data.user
                                                ? _vm.data.user.name +
                                                    "-" +
                                                    "" +
                                                    _vm.data.type +
                                                    _vm.data.id
                                                : ""
                                            ) +
                                            "\n                                            "
                                        ),
                                      ]),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "form-group mb-2 d-flex align-items-center",
                        },
                        [
                          _c(
                            "small",
                            {
                              staticClass: "input-title",
                              staticStyle: { width: "140px" },
                            },
                            [_vm._v("Valor: ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "ml-2",
                              staticStyle: { width: "calc(100% - 140px)" },
                            },
                            [
                              _c("input", {
                                staticClass:
                                  "form-control form-control-sm text-muted bg-white",
                                staticStyle: {
                                  "font-size": "11px",
                                  height: "31px",
                                  display: "flex",
                                  "align-items": "center",
                                },
                                attrs: { type: "text", readonly: "" },
                                domProps: {
                                  value: Number(_vm.data.value || 0).toFixed(2),
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "form-group mb-2 d-flex align-items-center",
                        },
                        [
                          _c(
                            "small",
                            {
                              staticClass: "input-title",
                              staticStyle: { width: "140px" },
                            },
                            [_vm._v("Remitente: ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "ml-2",
                              staticStyle: { width: "calc(100% - 140px)" },
                            },
                            [
                              _c("input", {
                                staticClass:
                                  "form-control form-control-sm text-muted bg-white",
                                staticStyle: {
                                  "font-size": "11px",
                                  height: "31px",
                                  display: "flex",
                                  "align-items": "center",
                                },
                                attrs: { type: "text", readonly: "" },
                                domProps: { value: _vm.data.shipper },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "form-group mb-2 d-flex align-items-center",
                        },
                        [
                          _c(
                            "small",
                            {
                              staticClass: "input-title",
                              staticStyle: { width: "140px" },
                            },
                            [_vm._v("Embalaje: ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "ml-2",
                              staticStyle: { width: "calc(100% - 140px)" },
                            },
                            [
                              _c("input", {
                                staticClass:
                                  "form-control form-control-sm text-muted bg-white",
                                staticStyle: {
                                  "font-size": "11px",
                                  height: "31px",
                                  display: "flex",
                                  "align-items": "center",
                                },
                                attrs: { type: "text", readonly: "" },
                                domProps: {
                                  value: _vm.data.packing
                                    ? _vm.data.packing.name
                                    : "",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "form-group mb-2 d-flex align-items-center",
                        },
                        [
                          _c(
                            "small",
                            {
                              staticClass: "input-title",
                              staticStyle: { width: "140px" },
                            },
                            [_vm._v("Peso: ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "ml-2",
                              staticStyle: { width: "calc(100% - 140px)" },
                            },
                            [
                              _c("input", {
                                staticClass:
                                  "form-control form-control-sm text-muted bg-white",
                                staticStyle: {
                                  "font-size": "11px",
                                  height: "31px",
                                  display: "flex",
                                  "align-items": "center",
                                },
                                attrs: { type: "text", readonly: "" },
                                domProps: {
                                  value: Number(_vm.data.weight || 0).toFixed(
                                    2
                                  ),
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "form-group mb-2 d-flex align-items-center",
                        },
                        [
                          _c(
                            "small",
                            {
                              staticClass: "input-title",
                              staticStyle: { width: "140px" },
                            },
                            [_vm._v("Dimensiones: ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "ml-2",
                              staticStyle: { width: "calc(100% - 140px)" },
                            },
                            [
                              _c("input", {
                                staticClass:
                                  "form-control form-control-sm text-muted bg-white",
                                staticStyle: {
                                  "font-size": "11px",
                                  height: "31px",
                                  display: "flex",
                                  "align-items": "center",
                                },
                                attrs: { type: "text", readonly: "" },
                                domProps: {
                                  value:
                                    Number(_vm.data.lengthy || 0).toFixed(2) +
                                    " x " +
                                    Number(_vm.data.width || 0).toFixed(2) +
                                    " x " +
                                    Number(_vm.data.tall || 0).toFixed(2),
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-lg-6" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "form-group mb-2 d-flex align-items-center",
                        },
                        [
                          _c(
                            "small",
                            {
                              staticClass: "input-title",
                              staticStyle: { width: "140px" },
                            },
                            [_vm._v("Descripción: ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "ml-2",
                              staticStyle: { width: "calc(100% - 140px)" },
                            },
                            [
                              _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "activator",
                                      fn: function (ref) {
                                        var on = ref.on
                                        var attrs = ref.attrs
                                        return [
                                          Array.isArray(_vm.data.description)
                                            ? _c(
                                                "div",
                                                _vm._g(
                                                  _vm._b(
                                                    {},
                                                    "div",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _c("input", {
                                                    staticClass:
                                                      "form-control form-control-sm text-muted bg-white",
                                                    staticStyle: {
                                                      "font-size": "11px",
                                                      height: "31px",
                                                      display: "flex",
                                                      "align-items": "center",
                                                    },
                                                    attrs: {
                                                      type: "text",
                                                      readonly: "",
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.data.description[0],
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      },
                                    },
                                  ]),
                                },
                                [
                                  _vm._v(" "),
                                  _c(
                                    "small",
                                    _vm._l(
                                      _vm.data.description,
                                      function (description, key) {
                                        return _c("div", { key: key }, [
                                          _vm._v(_vm._s(description)),
                                        ])
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "form-group mb-2 d-flex align-items-center",
                        },
                        [
                          _c(
                            "small",
                            {
                              staticClass: "input-title",
                              staticStyle: { width: "140px" },
                            },
                            [_vm._v("Tracking: ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "ml-2",
                              staticStyle: { width: "calc(100% - 140px)" },
                            },
                            [
                              _c("input", {
                                staticClass:
                                  "form-control form-control-sm text-muted bg-white",
                                staticStyle: {
                                  "font-size": "11px",
                                  height: "31px",
                                  display: "flex",
                                  "align-items": "center",
                                },
                                attrs: { type: "text", readonly: "" },
                                domProps: { value: _vm.data.tracking },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.data.tax
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "form-group mb-2 d-flex align-items-center",
                            },
                            [
                              _c(
                                "small",
                                {
                                  staticClass: "input-title",
                                  staticStyle: { width: "140px" },
                                },
                                [_vm._v("Impuesto: ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "ml-2",
                                  staticStyle: { width: "calc(100% - 140px)" },
                                },
                                [
                                  _c("input", {
                                    staticClass:
                                      "form-control form-control-sm text-muted bg-white",
                                    staticStyle: {
                                      "font-size": "11px",
                                      height: "31px",
                                      display: "flex",
                                      "align-items": "center",
                                    },
                                    attrs: { type: "text", readonly: "" },
                                    domProps: {
                                      value:
                                        Number(
                                          _vm.data.tax.value * 100 || 0
                                        ).toFixed(2) + "%",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "form-group mb-2 d-flex align-items-center",
                        },
                        [
                          _c(
                            "small",
                            {
                              staticClass: "input-title",
                              staticStyle: { width: "140px" },
                            },
                            [_vm._v("Piezas: ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "ml-2",
                              staticStyle: { width: "calc(100% - 140px)" },
                            },
                            [
                              _c("input", {
                                staticClass:
                                  "form-control form-control-sm text-muted bg-white",
                                staticStyle: {
                                  "font-size": "11px",
                                  height: "31px",
                                  display: "flex",
                                  "align-items": "center",
                                },
                                attrs: { type: "text", readonly: "" },
                                domProps: { value: _vm.data.pieces },
                              }),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "form-group mb-2 d-flex align-items-center",
                        },
                        [
                          _c(
                            "small",
                            {
                              staticClass: "input-title",
                              staticStyle: { width: "140px" },
                            },
                            [_vm._v("Peso Volumétrico: ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "ml-2",
                              staticStyle: { width: "calc(100% - 140px)" },
                            },
                            [
                              _c("input", {
                                staticClass:
                                  "form-control form-control-sm text-muted bg-white",
                                staticStyle: {
                                  "font-size": "11px",
                                  height: "31px",
                                  display: "flex",
                                  "align-items": "center",
                                },
                                attrs: { type: "text", readonly: "" },
                                domProps: {
                                  value: Number(
                                    _vm.data.volumetric_weight || 0
                                  ).toFixed(2),
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.data.awb
                      ? _c("div", { staticClass: "col-lg-6" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "form-group mb-2 d-flex align-items-center",
                            },
                            [
                              _c(
                                "small",
                                {
                                  staticClass: "input-title",
                                  staticStyle: { width: "140px" },
                                },
                                [_vm._v("AWB: ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "ml-2",
                                  staticStyle: { width: "calc(100% - 140px)" },
                                },
                                [
                                  _c("input", {
                                    staticClass:
                                      "form-control form-control-sm text-muted bg-white",
                                    staticStyle: {
                                      "font-size": "11px",
                                      height: "31px",
                                      display: "flex",
                                      "align-items": "center",
                                    },
                                    attrs: { type: "text", readonly: "" },
                                    domProps: { value: _vm.data.awb.awb },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.data.hawb
                      ? _c("div", { staticClass: "col-lg-6" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "form-group mb-2 d-flex align-items-center",
                            },
                            [
                              _c(
                                "small",
                                {
                                  staticClass: "input-title",
                                  staticStyle: { width: "140px" },
                                },
                                [_vm._v("HAWB: ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "ml-2",
                                  staticStyle: { width: "calc(100% - 140px)" },
                                },
                                [
                                  _c("input", {
                                    staticClass:
                                      "form-control form-control-sm text-muted bg-white",
                                    staticStyle: {
                                      "font-size": "11px",
                                      height: "31px",
                                      display: "flex",
                                      "align-items": "center",
                                    },
                                    attrs: { type: "text", readonly: "" },
                                    domProps: { value: _vm.data.hawb.hawb },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "form-group mb-2 d-flex align-items-center",
                        },
                        [
                          _c(
                            "small",
                            {
                              staticClass: "input-title",
                              staticStyle: { width: "140px" },
                            },
                            [_vm._v("Archivos Adjuntos: ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "ml-2",
                              staticStyle: { width: "calc(100% - 140px)" },
                            },
                            [_c("div", { staticClass: "py-3" })]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row" },
                        _vm._l(_vm.data.files, function (item, index) {
                          return _c(
                            "div",
                            { staticClass: "col-lg-1 col-md-2 col-sm-3 col-4" },
                            [
                              _c("img", {
                                staticClass: "img-fluid",
                                attrs: { src: "" + item.path },
                              }),
                            ]
                          )
                        }),
                        0
                      ),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-h btn-dark px-3",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("onclose")
                      },
                    },
                  },
                  [_vm._v("Cerrar")]
                ),
              ]),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }